import { status } from '@/alas';
import { defineComponent, ref, computed, onMounted, onUnmounted } from '@vue/composition-api';
export default defineComponent({
    setup(props, context) {
        let route = context.root.$route;
        // ================
        //
        // refs
        //
        let farm = ref(status.fetch('farm'));
        let types = ref(status.fetch('types'));
        // ================
        //
        // computed
        //
        let done = computed(() => types.value.o.fetch.done && farm.value.$o.fetch.done);
        let error = computed(() => types.value.o.fetch.error || farm.value.$o.fetch.error);
        // ================
        //
        // mounted
        //
        onMounted(() => {
            types.value.o.fetch.seek();
            farm.value.$o.fetch.start({
                farmId: route.params.id
            });
        });
        onUnmounted(() => {
            status.reset('farm');
            status.reset('cycles');
        });
        // ================
        //
        // done
        //
        return {
            done,
            error
        };
    }
});
